import React from "react";
import styles from '../TemplatesPreview.module.scss';

const ElementPhone = ({ value }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.groupName}>Номер телефона:&nbsp;</div>
      <div className={styles.groupCOnteiner}>
        <a href={`tel:+7${value}`} target="_blank" rel="noopener noreferrer" className={styles.groupValue}>{`+7${value}`}</a>
      </div>
    </div>
  )
}

export default ElementPhone;